var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(" 승인 ")]):_c('span',{staticClass:"font-weight-black",class:_vm.request.status},[_vm._v(" "+_vm._s(_vm._f("code")(_vm.request.status,'LoansRequest.Status'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }